module.exports = __webpack_public_path__ + "static/img/アセット 62@3x.863671d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/アセット 62@3x.png
// module id = oGp/
// module chunks = 1